export default "__VITE_ASSET__BmUl7Jdk__"